module.exports = __webpack_public_path__ + "static/media/btg_10.4623a604.png";